import React from "react";
import { Fragment, useEffect, useRef, useState } from "react";

import { mergeClasses } from "../../redux/constants";

export default function Button(props) {
  return (
    <input
      className={
        ("px-6 bg-indigo-800 text-white font-semibold mx-auto rounded-md hover:bg-indigo-600 cursor-pointer",
        props.className)
      }
      type="button"
      value={props.label}
      onClick={(e) => props.handleClick(e)}
    />
  );
}
